// Both cockpit sockets refuse and retry independently; one shared rule so the two
// can't drift apart.

// The route only checks the session on entry, so without this a tab whose session died
// reconnects anonymously forever — canary logs show single tabs racking up ~5k refusals
// over hours. Three tolerates one stale token before bouncing anyone out.
export const AUTH_REFUSALS_BEFORE_REAUTH = 3;

// ...and must span this long. Three refusals can land within seconds while a failing
// mint is negative-cached, and bouncing a working session mid-shift is the worse bug.
export const AUTH_REFUSAL_WINDOW_MS = 30_000;

// Is the SESSION gone, as opposed to a token that merely needs re-minting?
export function isAuthGenuinelyLost(
  refusals: number,
  firstRefusalAt: number | null,
  now: number,
): boolean {
  if (refusals < AUTH_REFUSALS_BEFORE_REAUTH) return false;
  if (firstRefusalAt === null) return false;
  return now - firstRefusalAt >= AUTH_REFUSAL_WINDOW_MS;
}
